import Notification from "../Notification";

export default class NewApplicantNotification extends Notification{
    constructor(data){
        super(data);
        this.jobId=data.data.job_id;
        this.jobTitle=data.data.job_title;
        this.applicationId=data.data.application_id;
        this.applicantName=data.data.applicant_name;
    }
    getTitle(){
        return 'ملاحظة جديدة على فرصة عمل'
    }
    getBody(){
        return ` قام "${this.applicantName}" المتقدم على فرصة العمل "${this.jobTitle}" ذات الرقم : #${this.jobId} بإرسال ملاحظة على الفرصة`
    }
    getActionLink(){
        return `/job-opportunities/feedback#applicants-feedback`
    }
}